import { useState, useEffect, useCallback } from 'react';
import { ApiFactory } from '../../core/config/ApiFactory';
import { IPedidoKDSExpedicao } from '../interfaces/IKDS';
import { useWebSocketKDSContext } from '../contexts/WebSocketKDSContext';

export const useKDSExpedicaoArea = (estacaoUuid: string) => {
    const [pedidos, setPedidos] = useState<IPedidoKDSExpedicao[]>([]);
    const [loading, setLoading] = useState(false);
    const api = ApiFactory.getApi("MS_PEDIDOS");
    const { registrarCallback, removerCallback, entrarSalaKDS } = useWebSocketKDSContext();

    const carregar = useCallback(async () => {
        if (!estacaoUuid) return;
        setLoading(true);
        try {
            const res = await api.get(`/kds/estacao/${estacaoUuid}/expedicao-area`);
            setPedidos(res.data.pedidos ?? []);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [estacaoUuid]);

    useEffect(() => {
        if (!estacaoUuid) return;
        entrarSalaKDS(`kds:${estacaoUuid}`);
        carregar();
        registrarCallback(carregar);
        const interval = setInterval(carregar, 15000);
        return () => {
            removerCallback(carregar);
            clearInterval(interval);
        };
    }, [carregar, estacaoUuid]);

    const iniciarItem = async (uuid: string) => {
        await api.patch(`/kds/item/${uuid}/iniciar`);
        await carregar();
    };

    const concluirItem = async (uuid: string) => {
        await api.patch(`/kds/item/${uuid}/concluir`);
        await carregar();
    };

    const concluirTodosItensPedido = async (pedidoUuid: string) => {
        await api.patch(`/kds/estacao/${estacaoUuid}/pedido/${pedidoUuid}/concluir`);
        await carregar();
    };

    const liberarPedido = async (pedidoUuid: string) => {
        await api.patch(`/kds/pedido/${pedidoUuid}/liberar`);
        await carregar();
    };

    const dispararPedido = async (pedidoUuid: string) => {
        await api.post(`/kds/pedido/${pedidoUuid}/disparar`);
        await carregar();
    };

    const dispararItemIndividual = async (itemUuid: string) => {
        await api.patch(`/kds/item/${itemUuid}/disparar`);
        await carregar();
    };

    const reverterItem = async (uuid: string) => {
        await api.patch(`/kds/item/${uuid}/reverter`);
        await carregar();
    };

    return {
        pedidos, loading, carregar,
        iniciarItem, concluirItem, concluirTodosItensPedido,
        liberarPedido, dispararPedido, dispararItemIndividual, reverterItem,
    };
};
